import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post(`/blinkit-onboarding/bulk-upload`, payload);
  },
};
